import { css, cx } from "@emotion/css"

import SelectContext from "./SelectContext"
import type { SelectProps } from "./SelectProps"

const Select = ({ shouldRender, className, ...props }: JSX.IntrinsicElements["select"] & SelectProps) => {
  return (
    <SelectContext.Provider value={{ shouldRender }}>
      <select {...props} className={cx(style, className)} />
    </SelectContext.Provider>
  )
}

export default Select

const style = css`
  font-family: inherit;
  border: 1px solid #cdd7e1;
  border-radius: 4px;
  padding: 4px 8px;
`
